export default "__VITE_ASSET__bc0f251a__"